import { render, staticRenderFns } from "./teamAdmin.vue?vue&type=template&id=2e145419&"
import script from "./teamAdmin.vue?vue&type=script&lang=js&"
export * from "./teamAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports